import styled from "styled-components";
import React from "react";
import Zoom from "./Zoom";
import BtnIcon from "./Btn/BtnIcon";
import { useIsListClicked } from "Provider/HomeProvider";
import { useHistory } from "react-router";
import TextParagraph from "./Text/TextParagraph";
import media from "Styles/media";

const Wrapper = styled.div`
	position: absolute;
	z-index: ${(props) => props.theme.zIndex.homeBtn};
	top: 0;
	left: 0;
	height: 100%;
	width: 100%;
	${(props) => props.theme.event.disable};
`;

const ZoomWrapper = styled(Zoom)<{ active: boolean }>`
	position: absolute;
	top: 50%;
	left: 0;
	transform: ${(props) => `
		translateX(${props.active ? props.theme.size.offset.pc + props.theme.size.logo.pc / 2 : 0}px) translate(-50%, -50%);
	`};
	transition: ${(props) => props.theme.transition.default};
	opacity: ${(props) => (props.active ? 1 : 0)};
	${(props) => props.theme.event.able};

	@media ${media.tablet} {
		transform: ${(props) => `
		translateX(${props.active ? props.theme.size.offset.tablet + props.theme.size.logo.tablet / 2 : 0}px) translate(-50%, -50%);
	`};
	}
`;

const BtnWrapper = styled.div`
	position: absolute;
	top: 50%;
	right: 0;
	transform: ${(props) => `
		translateX(${(props.theme.size.offset.pc + props.theme.size.logo.pc / 2) * -1}px ) translate(50%, -50%);
	`};
	${(props) => props.theme.event.able};

	@media ${media.tablet} {
		transform: ${(props) => `
		translateX(${(props.theme.size.offset.tablet + props.theme.size.logo.tablet / 2) * -1}px ) translate(50%, -50%);
	`};
	}

	@media ${media.mobile} {
		display: none;
	}
`;

const BtnDefault = styled(BtnIcon)`
	&:not(:last-child) {
		margin-bottom: 12px;
	}
`;

const TextWrapper = styled.div`
	position: absolute;
	bottom: ${(props) => `${props.theme.size.offset.pc + props.theme.size.logo.pc / 2}px`};
	right: ${(props) => `${props.theme.size.offset.pc + props.theme.size.logo.pc / 2}px`};
	text-align: right;
	color: ${(props) => props.theme.color.white};
	font-family: ${(props) => props.theme.font.inconsolata};
	display: flex;
	align-items: center;
`;

const InfoWrap = styled.div``;

const BtnArrow = styled(BtnDefault)`
	${(props) => props.theme.event.able};

	@media ${media.hover} {
		display: none;
	}
`;

const HomeUI: React.FC<{ title: string; value: string; id: string; setNowId: any }> = ({ title, value, id, setNowId }) => {
	const { setIsListClicked, isListClicked } = useIsListClicked();
	const { push } = useHistory();

	const handleListClick = () => {
		setIsListClicked((n) => !n);
	};
	const handleAboutClick = () => {
		push("/about");
	};
	const handleClick = (id: string) => {
		setNowId(id);
	};

	return (
		<Wrapper>
			<ZoomWrapper active={!isListClicked} />
			<BtnWrapper>
				<BtnDefault icon={isListClicked ? "space" : `list`} onClick={handleListClick} />
				<BtnDefault icon="project" onClick={handleAboutClick} />
			</BtnWrapper>

			{!isListClicked && (
				<TextWrapper>
					<InfoWrap>
						<TextParagraph value={title} effect={true} />
						<TextParagraph value={value ? `created by ${value}` : value} effect={true} />
					</InfoWrap>
					{title && value && id && <BtnArrow icon="right" onClick={() => handleClick(id)} />}
				</TextWrapper>
			)}
		</Wrapper>
	);
};

export default HomeUI;
